import React, { useCallback } from 'react'
import ProgressBanner from '../../components/Banner/ProgressBanner'
import { StepContainer } from '../../components/Steps/StepContainer'
import styles from './SignupPage.module.css'
import { useStepHandler } from '../../hooks/useStepHandler'
import { STEPS } from '../../constants/progressBanner'
import { submitRegistration } from '../api/registrationApi'
import { FormValues } from '../../components/Store/reducers/formReducer/types'
import { useAbTestIssuePattern } from '../../hooks/useAbTestIssuePattern'

const Pages = ({ webhookUrl }: { webhookUrl: string }) => {
    // DEV-3482: 施策番号を指定して引く。useAbTest だと「このパスで有効な施策」を施策を問わず
    // 拾うため、将来 /signup に一致する別施策が増えたときに、そのパターンでステップ順まで
    // 変わってしまう（DEV-3391 でこの誤発火のために useAbTestIssuePattern を用意した）
    const testPattern = useAbTestIssuePattern('3482')

    const {
        stepState,
        displayState,
        formState,
        handleNext,
        handlePrev,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        setStepStatus,
        setSkippedSteps,
        isBlocking,
    } = useStepHandler()
    const currentStep = stepState.currentStep.currentStep

    const handleRegistration = useCallback(async (data: FormValues) => {
        return submitRegistration(data)
    }, [])

    return (
        <div>
            {/* 1問目だけ見出しを出すのはA/B/C共通（Figmaどおり。2問目以降はロゴのみ） */}
            <ProgressBanner
                currentStep={currentStep}
                headerTitle={
                    currentStep <= STEPS.WORKING_STATUS
                        ? '新規会員登録'
                        : undefined
                }
                testPattern={testPattern}
            />
            <div className={styles.steps}>
                <StepContainer
                    stepState={stepState}
                    displayState={displayState}
                    formState={formState}
                    stepBoolean={stepState.stepStatus}
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    setFormValue={setFormValue}
                    updateUserResume={updateUserResume}
                    setDisplayValue={setDisplayValue}
                    setStepStatus={setStepStatus}
                    setSkippedSteps={setSkippedSteps}
                    webhook={webhookUrl}
                    isBlocking={isBlocking}
                    testPattern={testPattern}
                    handleRegistration={handleRegistration}
                />
            </div>
        </div>
    )
}

export default Pages
